import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/@shared';
import { I18nModule } from '@app/i18n';
import { LearninglabActivityComponent } from '@app/learning-lab/activity/activity.component';
import { TranslateModule } from '@ngx-translate/core';
import { AccountShellComponent } from './account-shell/account-shell.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { InstructorHeaderComponent } from './components/instructor-header/instructor-header.component';
import { InstructorSidebarComponent } from './components/instructor-sidebar/instructor-sidebar.component';
import { WelcomeShellComponent } from './components/welcome-shell/welcome-shell.component';
import { FeaturedCoursesComponent } from './featured-courses/featured-courses.component';
import { GeneralShellComponent } from './general-shell/general-shell.component';
import { InstructorShellComponent } from './instructor-shell/instructor-shell.component';
import { LearninglabCertificateShellComponent } from './learninglab-certificate-shell/learninglab-certificate-shell.component';
import { LearninglabShellComponent } from './learninglab-shell/learninglab-shell.component';
import { StudentShellComponent } from './student-shell/student-shell.component';
import { TermsShellComponent } from './terms-shell/terms-shell.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    I18nModule,
    RouterModule,
    SharedModule,
    WelcomeShellComponent,
    TermsShellComponent,
    FooterComponent,
    LearninglabActivityComponent,
    HeaderComponent,
    InstructorHeaderComponent,
    InstructorSidebarComponent,
    FeaturedCoursesComponent,
    GeneralShellComponent,
    InstructorShellComponent,
    LearninglabCertificateShellComponent,
    LearninglabShellComponent,
    StudentShellComponent,
    AccountShellComponent,
  ],
  declarations: [],
})
export class ShellModule {}
